var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.1913V20.577C29 23.3409 26.7625 25.5783 23.9986 25.5783H8.00138C5.23746 25.5783 3 23.3409 3 20.577V10.3469C3 9.98792 3.05983 9.64093 3.17948 9.31788L13.6967 17.143C15.0607 18.16 16.9393 18.16 18.3033 17.143L28.8564 9.29395C28.9521 9.58111 29 9.88023 29 10.1913Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8566 9.29395L18.3035 17.143C16.9395 18.16 15.061 18.16 13.6969 17.143L3.17969 9.31788",
    stroke: "#B3B3B3",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5V10.5C3 8.567 4.567 7 6.5 7H25.5C27.433 7 29 8.567 29 10.5V10.5",
    stroke: "#B3B3B3",
    strokeWidth: 1.81
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.d730f10a2968a5d96dd33f29af08801e.svg";
export { ForwardRef as ReactComponent };